const uniqueButtons = document.querySelectorAll(".unique-button");
let currentUniqueImage = document.querySelector(".unique-displayed-image");

if (currentUniqueImage) {
  // Mapping of images to their respective URLs
  const uniqueImageUrls = {
    "https://cdn.shopify.com/s/files/1/1185/8658/files/Minimalist_11-1.webp?v=1729169767":
      "/collections/the-minimalist-collection",
    "https://cdn.shopify.com/s/files/1/1185/8658/files/Voyager_1.webp?v=1727792876":
      "/collections/the-voyager-collection",
    "https://cdn.shopify.com/s/files/1/1185/8658/files/Aesthete_1.webp?v=1727793392":
      "/collections/the-aesthete-collection",
    "https://cdn.shopify.com/s/files/1/1185/8658/files/Provocateur_1.webp?v=1727793392":
      "/collections/the-provocateur-collection",
    "https://cdn.shopify.com/s/files/1/1185/8658/files/her2_1.webp?v=1727794278":
      "/collections/the-heritage-collection",
  };
  
  // Set the default image for the first button
  currentUniqueImage.style.backgroundImage =
    "url('https://cdn.shopify.com/s/files/1/1185/8658/files/Minimalist_11-1.webp?v=1729169767')";
  
  // Add click event to the current image
  currentUniqueImage.addEventListener("click", () => {
    const currentUniqueImageUrl =
      currentUniqueImage.style.backgroundImage.split('"')[1];
    const uniqueRedirectUrl = uniqueImageUrls[currentUniqueImageUrl];
    if (uniqueRedirectUrl) {
      window.location.href = uniqueRedirectUrl;
    }
  });
  
  // Add event listeners to each button
  uniqueButtons.forEach((button) => {
    button.addEventListener("click", () => {
      uniqueButtons.forEach((btn) => btn.classList.remove("unique-selected"));
  
      button.classList.add("unique-selected");
  
      const newUniqueImageUrl = button.getAttribute("data-image");
      const newUniqueImage = document.createElement("div");
      newUniqueImage.classList.add("unique-displayed-image");
      newUniqueImage.style.backgroundImage = `url('${newUniqueImageUrl}')`;
      newUniqueImage.classList.add("unique-image-hidden");
  
      currentUniqueImage.parentElement.appendChild(newUniqueImage);
  
      setTimeout(() => {
        newUniqueImage.classList.remove("unique-image-hidden");
        currentUniqueImage.classList.add("unique-image-hidden");
      }, 10);
  
      setTimeout(() => {
        currentUniqueImage.remove();
        currentUniqueImage = newUniqueImage;
  
        currentUniqueImage.addEventListener("click", () => {
          const newUniqueImageUrlInClick =
            currentUniqueImage.style.backgroundImage.split('"')[1];
          const uniqueRedirectUrlInClick =
            uniqueImageUrls[newUniqueImageUrlInClick];
          if (uniqueRedirectUrlInClick) {
            window.location.href = uniqueRedirectUrlInClick;
          }
        });
      }, 500);
    });
  });
}
